import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DatePipe, NgClass } from '@angular/common';
import { MatIconButton } from '@angular/material/button';
import { Notification } from '@app/pages/notifications/models/notification.model';
import { RouterLink } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-notification-card',
  imports: [DatePipe, MatIconButton, NgClass, RouterLink, TranslatePipe],
  templateUrl: './notification-card.component.html',
  styleUrl: './notification-card.component.scss'
})
export class NotificationCardComponent {
  @Input({ required: true }) notification!: Notification;
  @Output() deleteNotification = new EventEmitter<string>();
  @Output() notificationViewed = new EventEmitter<string>();

  private hoverTimeout!: ReturnType<typeof setTimeout>;

  public onMouseEnter(): void {
    this.hoverTimeout = setTimeout(() => {
      this.notificationViewed.emit(this.notification.id);
    }, 1500);
  }

  public onMouseLeave(): void {
    if (this.hoverTimeout) {
      clearTimeout(this.hoverTimeout);
    }
  }

  public onDelete(): void {
    this.deleteNotification.emit(this.notification.id);
  }

  public getNotificationLink(message: string): string {
    const linkMatch = message.match(
      /(procurement\/tender-auction\/tender-journal\/[a-zA-Z0-9\-]+)/
    );
    return linkMatch ? '/' + linkMatch[0] : '';
  }
}
